module.exports = __webpack_public_path__ + "img/partner_logo03.3cb52655.png";